import Control from "./Control.js"

export default class Unmute extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-unmute", true)
    this.state.altText = "MSG_UNMUTE"
    this.state.dismissed = false
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onmutechange(event) {
    if (event.detail === false)
      this.setState({dismissed: true})
  }

  onClick(event) {
    this.player.muted = false
    event.stopPropagation()
  }

  render() {
    if (this.state.dismissed === true)
      return null

    return (
      <div className="amp-unmute-layer" onClick={this.propsList.onClick}>
        {super.render()}
      </div>
    )
  }
}
